<template>
  <div class="pa-page pa-page-connections">
    <router-view></router-view>
  </div>
</template>

<script>
import LoginedPageMixins from '@/mixins/LoginedPageMixins'

export default {
  mixins : [
    LoginedPageMixins
  ],

  async mounted(){
    await this.initializePage({
      title : 'メルティングポッド'
    });
  }
}
</script>

<style lang="scss">
.pa-page{
  &-connections{
  }
}
</style>